<template>
  <VideoSection />
  <AboutSection />
  <HowToOrderSection />
  <WhyUsSection />
  <ReviewSection />
  <FAQSection />
  <GallerySection />
  <LocalizationSection />
</template>
<script setup lang="ts">
import AboutSection from "@/components/sections/AboutSection.vue";
import FAQSection from "@/components/sections/FAQSection.vue";
import GallerySection from "@/components/sections/GallerySection.vue";
import HowToOrderSection from "@/components/sections/HowToOrderSection.vue";
import LocalizationSection from "@/components/sections/LocalizationSection.vue";
import ReviewSection from "@/components/sections/ReviewSection.vue";
import VideoSection from "@/components/sections/VideoSection.vue";
import WhyUsSection from "@/components/sections/WhyUsSection.vue";
</script>
